export default __webpack_public_path__ + "static/media/2010.193ada40.jpg";